import * as React from 'react';
import * as cases from "./style.module.scss";
export const casesData = [
  {
    pic: "https://fs.advance.ru/landing-pages/about/Group-382.png",
    title: <>Сюжет<br/>на Первом канале</>,
    desc: "Николай Ягодкин рассказывает о современных методах, с помощью которых можно быстро выучить иностранный язык",
    content:
      <div className={cases.modal}>
        <div className={cases.vid}>
          <div className={cases.bg}>
            <iframe src="https://65395.servicecdn.ru/videos/65395_lYBC3ZOTIKCVB7k0" title={"Николай Ягодкин рассказывает о современных методах, с помощью которых можно быстро выучить иностранный язык"} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
          </div>
        </div>
      </div>
  },
  {
    pic: "https://fs.advance.ru/landing-pages/about/keis-02-korporat.png",
    title: <>Корпоративное<br/>обучение</>,
    desc: "Тренинги для сотрудников крупнейших корпораций",
    content:
      <div className={cases.modal}>
        <h3>Корпоративное обучение</h3>
        <img src="https://fs.advance.ru/landing-pages/about/Group-300.png" alt={""}/>
        <p>Затраты на адаптацию нового сотрудника часто достигают его трехмесячной зарплаты, вот почему всегда выгоднее развивать уже имеющихся сотрудников, а не нанимать новых. </p>

        <p>Но именно поэтому не так важно, что умеет сотрудник сейчас, как то, насколько быстро он умеет учиться новому и будет адаптироваться к изменениям. Вот почему лидеры рынка заботятся о навыках обучения и работы с информацией. </p>

        <p>Еще для корпоративных клиентов очень важна профилактика выгорания и повышение интеллектуальной выносливости сотрудников. Это тесно связанные вещи, и наши курсы отлично справляются с обеими задачами. Ведь если человек с работы уходит как выжатый лимон, то у него нет сил на отдых и скоро исчезнут силы и на работу. Развитая интеллектуальная выносливость позволяет сохранять высокий интеллектуальный тонус и после работы, а значит качественнее отдыхать и иметь больше впечатлений от остальных сфер жизни, что в свою очередь выгодно любому работодателю. </p>

        <p>Мы имеем опыт работы с руководителями и сотрудниками крупнейших промышленных и финансовых предприятий.</p>

        <p>В ходе обучения для сотрудников Сбербанка средняя оценка от участников составила — 9,3 из 10.</p>

        <p>Подобные мастер-классы мы проводили для ОТП-банка, Альфа-Банка, Газпром Трансгаз Санкт-Петербург, Novartis, RBI  и многих других. </p>
      </div>
  },
  {
    pic: "https://fs.advance.ru/landing-pages/about/keis-03-fifa.png",
    title: <>Подготовка<br/>казанских врачей</>,
    desc: "к Чемпионату мира по футболу в 2018 году",
    content:
      <div className={cases.modal}>
        <p>В 2018 году, в Казани, 300 врачей скорой помощи за месяц выучили английский язык вместе с Advance. </p>

        <p>У многих из них занятия проходили в конце 24-х часовой смены. Но наши технологии поднятия интеллектуального тонуса и методики обучения даже в таких условиях показали стабильный результат. На каждого медика приходилось порядка 60 часов обучения в мини-группах. </p>

        <p>Каждый врач сдал навыковый экзамен, продемонстрировав умение расспросить пациента про симптомы, в какой части тела, какие ощущения, объяснить рекомендованное лечение или условия госпитализации и необходимую для страховой компании информацию. И все это без разговорников или памяток. Безусловно, полученный навык пригодится им во всей последующей работе. </p>
      </div>
  },
  {
    pic: "https://fs.advance.ru/landing-pages/about/Group-388.png",
    title: <>Екатерина Климова<br/>в программе<br/>«Вечерний Ургант»</>,
    desc: "о своём опыте обучения в Advance",
    content:
      <div className={cases.modal}>
        <div className={cases.vid}>
          <div className={cases.bg}>
            <iframe src="https://65395.servicecdn.ru/videos/65395_e99gIpceUMNGKBE" title={"Екатерина Климова в" +
              " программе «Вечерний Ургант»"} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
          </div>
        </div>
      </div>
  },
  {
    pic: "https://fs.advance.ru/landing-pages/about/keis-05-himki.png",
    title: <>Технологии Advance<br/>в одной из лучших<br/>школ России</>,
    content:
      <div className={cases.modal}>
        <p>Как войти в 10 лучших школ Московской области по функциональной грамотности учащихся? И можно ли сделать это по итогам независимого международного исследования PISA? Может ли школа без математического уклона занять третье место по математической грамотности в регионе? </p>

        <p>На эти вопросы ответ есть у педагогов Химкинского Лицея! </p>

        <p>Химкинский лицей с 2017 года начал обучать своих учеников и педагогов по нашей системе и теперь использует технологии ускоренного обучения каждый день. </p>

        <p>За время курса средний показатель по ученикам школы вырос на 44%, а самые мотивированные школьники повысили результаты в 4–5 раз.</p>

        <p>Благодаря технологиям Advance ученики усваивают новую информацию в 2–4 раза быстрее, чем обычные школьники. Каждый учитель лицея переработал свои уроки и внедрил в них новые способы обучения.</p>

        <p>Еще более важно, что пример Химкинского лицея вдохновил соседние школы и сейчас технологии Advance внедряют еще 2 школы Городского Округа “Химки”: № 5 и 27.  </p>

        <p><a href="https://fs.advance.ru/landing-pages/about/documents/himki.pdf" target="_blank" rel={"noreferrer"}>Познакомиться с подробным отчетом о результатах внедрения</a></p>
      </div>
  },
  {
    pic: "https://fs.advance.ru/landing-pages/about/keis-06-asi.png",
    title: <>Advance в семёрке<br/>лидеров инновационного образования</>,
    content:
      <div className={cases.modal}>
        <p>В 2019 мы получили поддержку АСИ (Агентство Стратегических Инициатив). Благодаря чему внедряем технологии эффективного обучения в школы России в рамках проекта «Учись Учиться».</p>

        <p>Сейчас в проекте участвуют более 90 школ из Камчатки, Якутии, Петербурга, Ленинградской, Тюменской, Калужской, Архангельской и Московской областей.</p>
      </div>
  },
  {
    pic: "https://fs.advance.ru/landing-pages/about/Group-383.png",
    title: <>Александр Згода<br/>на канале «Россия 1»</>,
    desc: "В программе «Утро России с Дмитрием Мурашевым» Александр Згода поделился секретами высокой мотивации",
    content:
      <div className={cases.modal}>
        <div className={cases.vid}>
          <div className={cases.bg}>
            <iframe src="https://65395.servicecdn.ru/videos/65395_CerHSWIN2cKTh3x" title={"Александр Згода на канале" +
              " «Россия 1»"} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
          </div>
        </div>
      </div>
  },
  {
    pic: "https://fs.advance.ru/landing-pages/about/keis-08-zarubezh.png",
    title: "Проект с высоким потенциалом",
    desc: "В 2021 году Advance признали проектом с высоким потенциалом для продвижения на зарубежный рынок образования",
    content:
      <div className={cases.modal}><p>Координационный совет АСИ Go Global поддержал эту идею.</p></div>
  },
  {
    pic: "https://fs.advance.ru/landing-pages/about/Group-384.png",
    title: <>Интервью<br/>генерального директора Advance каналу<br/>«ТВ Центр»</>,
    content:
      <div className={cases.modal}>
        <div className={cases.vid}>
          <div className={cases.bg}>
            <iframe src="https://65395.servicecdn.ru/videos/65395_I6r8GPo9Qf8jqAcc" title={"Интервью генерального директора Advance каналу «ТВ Центр»"} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
          </div>
        </div>
      </div>
  },
  {
    pic: "https://fs.advance.ru/landing-pages/about/Group-385.png",
    title: <>Николай Ягодкин<br/>на Первом канале</>,
    desc: "В программе «Доброе утро» Николай Ягодкин рассказал о том, зачем нужно развивать память и как это делать",
    content:
      <div className={cases.modal}>
        <div className={cases.vid}>
          <div className={cases.bg}>
            <iframe src="https://vk.com/video_ext.php?oid=-19444929&id=456241979&hash=5ef5aaa913455ae2&hd=2" title={"Николай Ягодкин на Первом канале"} allow="autoplay; encrypted-media; fullscreen; picture-in-picture;" frameBorder="0" allowFullScreen></iframe>
          </div>
        </div>
      </div>
  },
  {
    pic: "https://fs.advance.ru/landing-pages/about/keis-09-top30.png",
    title: <>Топ-30 компаний России<br/>и топ-5 онлайн-школ</>,
    desc: "Топ-30 EdTech-компаний Россиии топ-5 онлайн-школ, использующих GetCourse",
    content:
      <div className={cases.modal}>
        <p>По итогам 2021 года РБК-Тренды опубликовали рейтинг, в котором Advance вошел в Топ-30 EdTech компаний России и Топ-5 онлайн-школ, использующих GetCourse. База подписчиков Advance официально является крупнейшей в GetCourse и составляет более 1,6 миллиона человек. </p>
      </div>
  },
  {
    pic: "https://fs.advance.ru/landing-pages/about/Group-386.png",
    title: <>Новостной сюжет<br/>на канале «НТВ»</>,
    desc: "Репортаж о самых востребованных профессиях с участием Николая Ягодкина",
    content:
      <div className={cases.modal}>
        <div className={cases.vid}>
          <div className={cases.bg}>
            <iframe src="https://vk.com/video_ext.php?oid=1087&id=162613233&hash=4c41a903ce8b5444&hd=1" title={"Новостной сюжет на канале «НТВ»"} allow="autoplay; encrypted-media; fullscreen; picture-in-picture;" frameBorder="0" allowFullScreen></iframe>
          </div>
        </div>
      </div>
  },
  {
    pic: "https://fs.advance.ru/landing-pages/about/keis-13-edm.png",
    title: <>«Энциклопедия<br/>детской мотивации»</>,
    desc: "В 2019 году Advance выпустил пособие с рекомендациями, как мотивировать детей",
    content:
      <div className={cases.modal}>
        <p>Книга стала для родителей настоящим учебником, в котором на ярких примерах разбирается кризис детской мотивации и как из него выйти. Акцент сделан как на самих инструментах, так и на принципах их работы. Информация основана на опыте преподавания Николая Ягодкина и всего центра Advance. На данный момент выпущено 3 издания. Последнее из них опубликовано под редакцией издательства «Бомбора»".</p>
      </div>
  },
  {
    pic: "https://fs.advance.ru/landing-pages/about/Group-387.png",
    title: <>«ТВ Центр» —<br/>эфир с Александром<br/>Згода</>,
    content:
      <div className={cases.modal}>
        <div className={cases.vid}>
          <div className={cases.bg}>
            <iframe src="https://nastroenie.tv/video/iframe/id/160864/isPlay/true/?acc_video_id=/episode/160864" title={"«ТВ Центр» — эфир с Александром Згода"} allowFullScreen="true" frameBorder="0"></iframe>
          </div>
        </div>
      </div>
  },
  {
    pic: "https://fs.advance.ru/landing-pages/about/keis-15-blago.png",
    title: "Cотрудничество с детскими некоммерческими и благотворительными организациями",
    content:
      <div className={cases.modal}>
        <p>Дети с индивидуальными особенностями развития или тяжелыми заболеваниями, а также сироты не могут посещать учебные заведения в силу лечения или ограниченных возможностей. По запросу некоммерческих и благотворительных организаций Advance открывает безвозмездный доступ к своим онлайн-курсам. Центр уже получил множество благодарственных писем, в которых говорится о росте когнитивных навыков у подопечных. Advance также регулярно проводит семинары и мастер-классы в крупнейших детских центрах страны, ВДЦ Смена, Орленок и других, сотрудничает с РДШ и ЭкоБиоЦентром.
        </p>
      </div>
  }
]
